import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'regulateSpecialChars'
})
export class RegulateSpecialCharsPipe implements PipeTransform {

  transform(type: any, textoption: any, numberoption:any,fieldtype:string) {
    if(fieldtype == 'Fields'){
      return textoption
    }else{
      if(type){
        if(type[1]=='text'){
            return textoption
        }else if(type[1]=='number'){
            return numberoption
        }else{
            return []
        }
      }
    }
  }
}